import React from "react";
import { Tooltip, TooltipProps } from "src/ui/shared/Tooltip";
import { makeStyles } from "tss-react/mui";

import { IconProps, MenuItem, MenuItemProps, Typography, TypographyProps, useTheme } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
    menuItem: {
        height: "1.85rem",
        "&.MuiMenuItem-root:hover": {
            backgroundColor: theme.palette.emteria.background.listHover,
        },
    },
    iconContainer: {
        width: 16,
        display: "inline-flex",
        justifyContent: "center",
        marginRight: theme.spacing(2),
    },
}));

interface DropdownItemProps extends MenuItemProps {
    label: string;
    button?: true;
    tooltipProps?: Omit<TooltipProps, "children">;
    iconProps?: Omit<IconProps, "children">;
    labelProps?: Omit<TypographyProps, "children">;
    iconName?: string;
    /** Marks a destructive entry (delete, shutdown) so its icon and label turn red. */
    danger?: boolean;
}

export function DropdownItem({
    tooltipProps = { title: "", hide: true },
    iconName,
    iconProps,
    labelProps,
    label,
    danger = false,
    ...props
}: DropdownItemProps): React.JSX.Element {
    const { classes } = useStyles();
    const theme = useTheme();

    const color = danger ? theme.palette.emteria.error : theme.palette.emteria.text.primary;

    return (
        <Tooltip {...tooltipProps}>
            <MenuItem className={classes.menuItem} {...props} disableRipple>
                {iconName ? (
                    <div className={classes.iconContainer}>
                        <i className={iconName} style={{ color }} {...iconProps} />
                    </div>
                ) : null}
                <Typography color={danger ? theme.palette.emteria.error : undefined} {...labelProps}>
                    {label}
                </Typography>
            </MenuItem>
        </Tooltip>
    );
}
